import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { OptionGroupType } from '@frontend/sports/betting-offer/feature/fixture-factories';
import { EventModel, EventOptionGroup } from '@frontend/sports/betting-offer/feature/model';
import { OptionPanelThreshold } from '@frontend/sports/types/configuration';

import { SourceOfPick } from '../betslip-base/models/pick-models';
import { LinkedOptionGroupComponent } from './linked-option-group.component';
import { RegularOptionGroupComponent } from './regular-option-group.component';

@Component({
    selector: 'ms-regular-group',
    templateUrl: './regular-group.component.html',
    imports: [RegularOptionGroupComponent, LinkedOptionGroupComponent],
})
export class RegularGroupComponent implements OnInit {
    @Input() event: EventModel;
    @Input() tracking: string;
    @Input() trackingModuleType = '';
    @Input() optionGroup: EventOptionGroup;
    @Input() thresholds?: OptionPanelThreshold[];
    @Input() showMarketHelp: boolean;
    @Input() crmPromotedOptionIdsMap: { [optionId: number]: number } = {};
    @Input() eventHelpText?: string;
    @Input() linkableGroup: boolean;
    @Input() sourceOfPick = SourceOfPick.Other;
    @Input() betDetails = '';
    @Input() optionsLimitOverride?: number;
    @Input() calendarTrack?: string;
    @Input() groupType: OptionGroupType;
    @Input() showPlayerStats: boolean;

    @Output() expandClicked = new EventEmitter<boolean>();
    @Output() showAllRequested = new EventEmitter<void>();

    showLinkedGroup: boolean;

    ngOnInit(): void {
        this.showLinkedGroup = this.linkableGroup && (this.optionGroup.linkedSibling || false);
    }

    onExpandedClicked(event: boolean): void {
        this.expandClicked.emit(event);
    }
}
